import { Link } from 'react-router-dom';

// Icons imports
import facebookIcon from '../images/facebook.png';
import instagramIcon from '../images/instagram.png';
import whatappIcon from '../images/whatsapp.png';
import youtubeIcon from '../images/youtube.png';

// Pages imports
import { PrivacyPolicy } from '../pages/PrivacyPolicy';
import { TermsService } from '../pages/TermsService';

export const Footer = () => {

    return (
        <footer class="bg-slate-900 dark:bg-[#050505] text-white text-left pt-20 pb-8">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
                    <div class="lg:col-span-2">
                        <div class="flex items-center gap-3 mb-6">
                            <div class="font-display font-bold text-4xl" style={{ color: 'rgb(242, 109, 33)' }}>FJ</div>
                            <div class="">
                                <span class="font-display text-2xl font-bold tracking-tighter text-white uppercase">Flacon Jeans</span>
                                <p class="text-[10px] uppercase tracking-[0.2em] font-semibold text-primary">Since
                                    2007</p>
                            </div>
                        </div>
                        <p class="text-slate-400 mb-8 max-w-md">
                            Suppliers of premium quality denim. We take pride in our industrial heritage and commitment to
                            excellence in women's fashion manufacturing.
                        </p>
                        <div class="flex gap-4">
                            <a class="w-8 h-8 border border-slate-700 flex items-center justify-center hover:bg-white/20 hover:border-white transition-colors"
                                href="#">
                                <img src={facebookIcon} alt="Facebook" class="w-5 h-5" />
                            </a>
                            <a class="w-8 h-8 border border-slate-700 flex items-center justify-center hover:bg-white/20 hover:border-white transition-colors"
                                href="#">
                                <img src={instagramIcon} alt="Instagram" class="w-5 h-5" />
                            </a>
                            <a class="w-8 h-8 border border-slate-700 flex items-center justify-center hover:bg-white/20 hover:border-white transition-colors"
                                href="#">
                                <img src={whatappIcon} alt="WhatsApp" class="w-5 h-5" />
                            </a>
                            <a class="w-8 h-8 border border-slate-700 flex items-center justify-center hover:bg-white/20 hover:border-white transition-colors"
                                href="#">
                                <img src={youtubeIcon} alt="YouTube" class="w-5 h-5" />
                            </a>
                        </div>
                    </div>
                    <div>
                        <h5 class="font-display font-bold uppercase tracking-widest text-primary mb-6">Quick Links
                        </h5>
                        <ul class="space-y-4 text-slate-400">
                            <li><Link to="/" class="hover:text-white transition-colors" href="#">Home</Link></li>
                            <li><Link to="/about" class="hover:text-white transition-colors">About Us</Link></li>
                            <li><Link to="/womens-jeans" class="hover:text-white transition-colors">Collection</Link></li>
                            <li><Link to="/contact" class="hover:text-white transition-colors">Contact</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h5 class="font-display font-bold uppercase tracking-widest text-primary mb-6">Location
                        </h5>
                        <div class="text-slate-400 space-y-4 text-sm leading-relaxed">
                            <p class="font-bold text-white uppercase tracking-wider">Om Clothing Co.</p>
                            <p>
                                E/2A, Gala No - 10, <br />
                                Asmeeta Textile Park, Kongaon, <br />
                                Kalyan Bhiwandi Road, <br />
                                Kalyan - 421302, <br />
                                Maharashtra, India
                            </p>
                            <div class="flex items-center gap-2 text-primary font-bold">
                                <span class="material-symbols-outlined text-sm">call</span>
                                <span>9870316550 | 9320541732</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-slate-500 uppercase tracking-widest">
                    <p>© 2026 - 2027 Flacon Jeans. All Rights Reserved.</p>
                    <div class="mt-4 md:mt-0 flex gap-6">
                        <Link to="/privacy-policy" element={<PrivacyPolicy />} class="hover:text-white transition-colors font-bold text-white">Privacy Policy</Link>
                        <Link to="/terms-of-service" element={<TermsService />} class="hover:text-white transition-colors font-bold text-white">Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}